import { Plus, Trash } from "lucide-react";
import { useState } from "react";

export function QuestionOptionsEditor({ q, onQuestionChange }:
    {
        q: PolicyFormQuestion;
        onQuestionChange: (id: string, updates: Partial<PolicyFormQuestion>) => void;
    }) {
    const [newOption, setNewOption] = useState({ id: "", value: "" });

    const handleAdd = () => {
        if (!newOption.id.trim() || !newOption.value.trim()) return;

        const updated = [...(q.options || []), { ...newOption }];
        onQuestionChange(q.questionRef, { options: updated });

        setNewOption({ id: "", value: "" });
    };

    return (
        <div className="ml-2 mt-2 border-l pl-3 space-y-2">
            {/* Existing options */}
            {(q.options || []).map((opt, idx) => (
                <div key={opt.id} className="flex items-center gap-2">
                    {/* Option ID */}
                    <input
                        type="text"
                        value={opt.id}
                        onChange={(e) => {
                            const updated = [...(q.options || [])];
                            updated[idx] = { ...opt, id: e.target.value };
                            onQuestionChange(q.questionRef, { options: updated });
                        }}
                        className="text-xs border rounded px-2 py-1 w-40 font-mono"
                        placeholder="Option ID"
                    />

                    {/* Option Value */}
                    <input
                        type="text"
                        value={opt.value}
                        onChange={(e) => {
                            const updated = [...(q.options || [])];
                            updated[idx] = { ...opt, value: e.target.value };
                            onQuestionChange(q.questionRef, { options: updated });
                        }}
                        className="text-sm border rounded px-2 py-1 flex-1"
                        placeholder="Option value"
                    />

                    {/* Remove button */}
                    <button
                        type="button"
                        className="text-red-500 hover:text-red-700"
                        onClick={() => {
                            const updated = (q.options || []).filter((_, i) => i !== idx);
                            onQuestionChange(q.questionRef, { options: updated });
                        }}
                    >
                        <Trash size={14} />
                    </button>
                </div>
            ))}

            {/* New option input row */}
            <div className="flex items-center gap-2 pt-2">
                <input
                    type="text"
                    value={newOption.id}
                    onChange={(e) => setNewOption({ ...newOption, id: e.target.value })}
                    className="text-xs border rounded px-2 py-1 w-40 font-mono"
                    placeholder="New Option ID"
                />
                <input
                    type="text"
                    value={newOption.value}
                    onChange={(e) => setNewOption({ ...newOption, value: e.target.value })}
                    className="text-sm border rounded px-2 py-1 flex-1"
                    placeholder="New Option Value"
                />
                <button
                    type="button"
                    className="flex items-center text-xs text-green-600 hover:text-green-700"
                    onClick={handleAdd}
                >
                    <Plus size={14} className="mr-1" /> Add
                </button>
            </div>
        </div>
    );
}